export async function generateHmacSHA256(
  message: string,
  secret: string
): Promise<string> {
  const encoder = new TextEncoder();

  const key = await window.crypto.subtle.importKey(
    "raw",
    encoder.encode(secret),
    {
      name: "HMAC",
      hash: "SHA-256",
    },
    false,
    ["sign"]
  );

  const signature = await window.crypto.subtle.sign(
    "HMAC",
    key,
    encoder.encode(message)
  );

  // ArrayBuffer → hex string (matches PHP output)
  return Array.from(new Uint8Array(signature))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}